const printMessageCustomer = () => {
    // Element selectors
    const selectors = {
        wrapper: ".mi-gallery--overlay",
        greetings: ".mi-gallery--overlay__greetings",
        message: ".mi-gallery--overlay__message",
    };

    const MINUTE_IN_MILLISECONDS = 60000;
    let defaultText = null;
    let visitData = [];
    const now = new Date();

    class MessageError extends Error {
        constructor(message, errorType) {
            super(message);
            this.name = "MessageError";
            this.errorType = errorType;
        }
    }

    const getElement = (selector) => {
        const element = document.querySelector(selector);
        if (!element) {
            throw new MessageError(`Element not found: ${selector}`, "DOM_ERROR");
        }
        return element;
    };

    const validateData = (data) => {
        if (!Array.isArray(data)) {
            throw new MessageError("Visit data must be an array", "DATA_ERROR");
        }

        if (data.length === 0) {
            // Set up interval to check and reload every 5 minutes (300,000 milliseconds)
            setInterval(checkAndReloadPage, 300000);
            // throw new MessageError("Visit data is empty", "DATA_ERROR");
        }

        data.forEach((item, index) => {
            if (!item.start || !item.end) {
                throw new MessageError(`Invalid data format at index ${index}`, "DATA_ERROR");
            }

            const startDate = new Date(item.start);
            const endDate = new Date(item.end);

            if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
                throw new MessageError(`Invalid date format at index ${index}`, "DATA_ERROR");
            }

            if (endDate < startDate) {
                throw new MessageError(
                    `End date is before start date at index ${index}`,
                    "DATA_ERROR",
                );
            }
        });
    };

    const init = () => {
        try {
            const wrapper = getElement(selectors.wrapper);

            // Get and validate the visit data
            visitData = wrapper.dataset.visit;
            try {
                visitData = JSON.parse(visitData);
            } catch (e) {
                throw new MessageError("Failed to parse visit data", "DATA_ERROR");
            }

            validateData(visitData);

            // Store default text
            defaultText = {
                title: getElement(selectors.message).textContent,
                content: getElement(selectors.greetings).textContent,
            };

            exec();
        } catch (error) {
            handleError(error);
        }
    };

    // Function to check and reload page if visitData is empty
    const checkAndReloadPage = () => {
        // Check if visitData is an empty array
        if (visitData && visitData.length === 0) {
            // Reload the page
            window.location.reload();
        }
    }

    const exec = () => {
        try {
            const dateArr = visitData
                .flatMap((item) => [
                    new Date(item.start),
                    new Date(item.end),
                ])
                .sort((a, b) => a - b);

            const past = findClosestStartTime(visitData);
            const future = findClosestUpcomingStartTime(visitData);
            const closestData = diffData(past, future);

            updateTextDOM(closestData);
            reloadWindow(dateArr);
        } catch (error) {
            handleError(error);
        }
    };

    const updateTextDOM = (data) => {
        try {
            const messageEl = getElement(selectors.message);
            const greetingsEl = getElement(selectors.greetings);

            messageEl.textContent = data.title;

            if (data.content?.toString().length) {
                greetingsEl.textContent = data.content;
            }
        } catch (error) {
            handleError(error);
        }
    };

    const findClosestStartTime = (appointments) => {
        if (!appointments.length) return null;

        return appointments.reduce((closest, current) => {
            const currentStartTime = new Date(current.start);
            const closestStartTime = new Date(closest.start);
            return Math.abs(currentStartTime - now) < Math.abs(closestStartTime - now)
                ? current
                : closest;
        });
    };

    const findClosestUpcomingStartTime = (appointments) => {
        const futureAppointments = appointments.filter(
            (appointment) => new Date(appointment.start) >= now,
        );

        return futureAppointments.length ? findClosestStartTime(futureAppointments) : null;
    };

    const diffData = (past, future) => {
        if (!past && !future) return defaultText;

        const pastStart = past ? new Date(past.start) - now : Infinity;
        const futureStart = future ? new Date(future.start) - now : Infinity;
        const min = Math.min(pastStart, futureStart);

        if (
            (min < 0 || pastStart <= MINUTE_IN_MILLISECONDS) &&
            past &&
            new Date(past.end) - now > 0
        ) {
            return past;
        } else if (future && futureStart <= MINUTE_IN_MILLISECONDS) {
            return future;
        } else {
            return defaultText;
        }
    };

    const reloadWindow = (timesArr) => {
        try {
            const currentTime = now.getTime();
            const nextReload = timesArr
                .map((date) => date.getTime())
                .find((timestamp) => timestamp > currentTime);

            if (nextReload) {
                const timeUntilReload = nextReload - currentTime;

                setTimeout(() => {
                    window.location.reload();

                    const updatedTimes = timesArr.filter((date) => date.getTime() > now.getTime());
                    if (updatedTimes.length) {
                        reloadWindow(updatedTimes);
                    }
                }, timeUntilReload);

                console.log(`Next reload scheduled for: ${new Date(nextReload).toLocaleString()}`);
            } else {
                console.log("No more reload times scheduled");
            }
        } catch (error) {
            handleError(error);
        }
    };

    const handleError = (error) => {
        // Log the error with additional context
        console.error("Message Handler Error:", {
            name: error.name,
            message: error.message,
            type: error instanceof MessageError ? error.errorType : "UNKNOWN_ERROR",
            stack: error.stack,
        });
    };

    // Initialize when DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
};

try {
    printMessageCustomer();
} catch (error) {
    console.error("Critical Error:", error);
}
